/**
 * Black-Swan Global Mixins
 *
 * @since: 2018-07-23
 * @author: kdydesign.kim
 */

import Vue from 'vue'

// global Navigation Guard
import NavigationGuard from './navigationGuard'

// global Validate Check
import Validator from './validator'
import CommMixin from './commMixin'

// global mixins
Vue.mixin(NavigationGuard)
Vue.mixin(Validator)
Vue.mixin(CommMixin)
